<template>
    <v-dialog v-model="dialogfilter" width="800px" scroll-strategy="none">
        <v-card :retain-focus="false" min-width="700px" class="pa-4 py-2"
            style="background-color:white; border-radius: 12px; overflow-y: hidden;">
            <h1>{{ $t('ColumnFilter.searchBy', { itm: title }) }}</h1>
            <div class="row">
              <div class="col-6 justify-content-start">
                <div class="row">
                    <v-card-title class="text-left">{{ $t('Brands.Name') }}</v-card-title>
                </div>
                <div class="row">
                    <v-text-field v-model="filterParams.BrandName" id="Title" name="Title" maxlength="30" hide-details
                        persistent-placeholder
                        :placeholder="$t('placeholder.enter', { itm: $t('Brands.PlaceHolderTags.Name') })"
                        variant="outlined" class="rounded-xl"></v-text-field>
                </div>
              </div>
               <div class="col-6 justify-content-start">
                <div class="row">
                     <v-card-title class="text-left ">{{ $t('Brands.Supplier')
                            }}</v-card-title>
                </div>
                <div class="row">
                    <v-autocomplete
                            :style="MySupplier ? 'pointer-events: none;' : ''"
                            v-model="filterParams.supplierId"
                             
                            :items="suppliers"
                            item-title="name"
                            item-value="supplierId"
                            persistent-placeholder
                            variant="outlined"
                            :placeholder="
                                $t('placeholder.select', {
                                    itm: $t('Brands.Supplier'),
                                })
                            "
                            hide-details
                        >
                            <template v-slot:item="{ props, item, index }">
                                <v-list-item
                                    v-bind="props"
                                    variant="text"
                                    :id="index"
                                    :name="item.brandName"
                                >
                                    {{ item.brandName }}
                                </v-list-item>
                            </template>
                        </v-autocomplete>
                </div>
             </div>
             <div class="col-6 justify-content-start">
                <div class="row">
                        <v-card-title class="text-left"
                            >{{ $t("Brands.Category")
                            }}</v-card-title
                        >
                    </div>
                    <div class="row">
                        <autocompleteGrouped
                            v-model="filterParams.IdCategories"
                            :items="categories"
                            :placeholder="
                                $t('placeholder.select', {
                                    itm: $t('Brands.Category'),
                                })
                            "
                        />
                    </div>
            </div>
            <div class="col-6 justify-content-start">
                    <div class="row">
                        <v-card-title class="text-left">{{ $t('clients.creationDate')
                            }}</v-card-title>
                    </div>
                    <dateField id="CreationDate" name="CreationDate" v-model="filterParams.CreationDate"
                        :min-date="new Date('2000-01-01')" :max-date="new Date()" :model-value="filterParams.CreationDate"
                        range-enabled @update:model-value="handleDateRangeCreationDate" 
                        ref="creationDateRef" position="top" />
                </div>
            </div>
           
            <div class="d-flex justify-content-center align-items-center mt-4">
                <card-actions :yes="confirm" v-model="dialogfilter" :no="dialogfilter" width="100px"
                    :yesTitle="$t('ColumnFilter.search')" @update:no="cancel">
                    <template v-slot:centerButton>
                        <genericBtnComponent width="100px" :ClickFun="cleardialogfilter"
                            :Title="$t('clients.clearBtn')" />
                    </template>
                </card-actions>
            </div>
            
        </v-card>
    </v-dialog>
</template>

<script>

    import autocompleteGrouped from "@/genericComponent/autocompleteGrouped.vue";
    import dateField from "@/genericComponent/date-field.vue";
    import cardActions from "@/genericComponent/cardActions.vue";
    import genericBtnComponent from "@/genericComponent/genericBtnComponent.vue"
export default {
  components: {
        autocompleteGrouped , dateField , cardActions , genericBtnComponent
    },
  mounted() {
        document.title = window.VUE_APP_NAME + ' - ' + this.$t('Document.Title.Brands');
          
    },
    props : {
        categories : {
            type : Array,
            default :() => []
        },
        suppliers : {
            type: Array,
            default :() => []
        }
    },
data () {
  return {
    dialogfilter : true,
    filterParams: {
                BrandName: null,
                IdCategories : [],
                supplierId: null,
                CreatedFrom: null,
                CreatedTo: null,
               
            },
    MySupplier :null,
    item:null,
    CreationDate : [],
    creationDateRef: null,
  }
},


methods : {
  
  confirm() {
            this.$emit('update:filteredbrands', this.filterParams
            );
        },
  cleardialogfilter() {
            this.filterParams.BrandName = null;
            this.filterParams.IdCategories = [];
            this.filterParams.supplierId = null;
            this.filterParams.CreatedFrom = null;
            this.filterParams.CreatedTo = null;
            this.CreationDate = [];
            if (this.$refs.creationDateRef) {
                this.$refs.creationDateRef.clearDateRange();
            }
            
        },
  cancel() {
            this.$emit('cancel');
        },
  handleDateRangeCreationDate(value) {
            if (Array.isArray(value) && value.length === 2) {
                this.filterParams.CreatedFrom = value[0];
                this.filterParams.CreatedTo = value[1];
            }
        },
},

}
</script>
<style scoped>
h1 {
    font-family: inter;
    font-size: 18px;
    line-height: 29px;
    font-weight: 600;
    color: #0d0849;
    text-align: center;
}

.custom-card-title {
    font-size: 16px;
    color: #5b6d8e;
}

.error-message {
    color: red;
    font-size: 14px;
}
</style>